// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__L8Mmk","logo":"Loading_logo__jcVdJ","spin360":"Loading_spin360__h8D5Y"};